import { render, staticRenderFns } from "./OrgPost.vue?vue&type=template&id=3c63137a&scoped=true&"
import script from "./OrgPost.vue?vue&type=script&lang=js&"
export * from "./OrgPost.vue?vue&type=script&lang=js&"
import style0 from "./OrgPost.vue?vue&type=style&index=0&id=3c63137a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c63137a",
  null
  
)

export default component.exports